// PT-BR
export const hotelCalendarHc = {
  toolbar: {
    bulkEdit: "Edição em massa",
    cfgTitle: "Configurações do calendário",
    syncSection: "Sincronização",
    resyncOta: "Ressincronizar com a OTA",
    resyncOtaSub: "Reenvia a disponibilidade e as tarifas ao canal.",
  },
  mode: {
    calendar: "Calendário",
    rates: "Tarifas",
  },
  search: {
    placeholder: "Buscar hóspede ou código…",
    clear: "Limpar",
    go: "Buscar",
    resultsHint: "{count} resultados — selecione um:",
    combo: "Combinada · {count} quartos",
  },
  header: {
    occupancy: "Ocupação {pct}%",
  },
  type: {
    roomsAbbr: "qtos",
    configTitle: "Configuração do tipo (OTA e regras de chegada/saída)",
    otaConnected: "OTA conectada",
    subscribeToConnect: "Assine para conectar OTAs",
  },
  rtCell: {
    editTooltip: "Clique para editar disponibilidade, preço, mínima e fechamento",
    overbookRisk: "Risco de overbooking",
    closedTag: "Fechado",
  },
  rules: {
    sameDayCutoff: "Corte de venda no mesmo dia às {time}",
  },
  organizeRow: {
    title: "Para organizar",
    unplacedCount: "{count} reserva sem alocação | {count} reservas sem alocação",
    autoTooltip: "Reorganiza automaticamente as reservas entre os quartos para que todas caibam",
    organizing: "Organizando…",
    organize: "Organizar",
  },
  footer: {
    available: "Disponível",
    unavailable: "Indisponível",
    closed: "Fechado",
    overbookRisk: "Risco de overbooking",
    realtime: "Os valores são atualizados em tempo real",
    timezone: "Fuso horário: {tz}",
  },
  dayEdit: {
    oneDay: "um dia",
    open: "Aberto",
    closed: "Fechado",
    priceLabel: "Preço · tarifa padrão",
    minStayLabel: "Estadia mínima (noites)",
    forSaleLabel: "Quartos à venda",
    forSaleHint: "limite · máx {max}",
    applyMultiple: "Aplicar a várias datas?",
    cancel: "Cancelar",
    saving: "Salvando…",
    save: "Salvar",
  },
  roomMenu: {
    create: "Criar reserva",
    createSub: "Reserva no intervalo selecionado",
    block: "Bloquear 1 quarto",
    blockSub: "Fecha este quarto no intervalo",
    unblock: "Remover bloqueio",
    unblockSub: "Reabre este quarto no intervalo",
    oos: "Fora de serviço",
    oosSub: "Manutenção deste quarto",
  },
  closureMenu: {
    turnoverTitle: "Definido pelo tempo de preparação",
    turnoverSub: "Move-se junto com as datas da reserva e desaparece se ela for cancelada.",
    changeRule: "Alterar a regra",
    changeRuleSub: "Ajustar ou desativar o tempo de preparação",
    editReason: "Alterar motivo",
    editReasonSub: "Alterar o motivo do bloqueio",
    changeRoom: "Trocar de quarto",
    changeRoomSub: "Mover para outro quarto do tipo",
    unblock: "Remover bloqueio",
    unblockSub: "Reabre e libera o espaço",
    moveTo: "Mover para…",
    noOtherRooms: "Não há outros quartos neste tipo.",
    barTooltip: "Bloqueio: {reason} — clique para alterar ou remover",
  },
  typeConfig: {
    seasons: "Price seasons",
    seasonsSub: "Raise or lower prices by date",
    manageOta: "Gerenciar conexão OTA",
    connectOta: "Conectar OTA",
    otaSub: "Sincroniza a acomodação com as OTAs",
    arrivalRules: "Regras de chegada e saída",
    arrivalRulesSub: "Dias permitidos de check-in / check-out",
  },
  // La habitación se ocupó unas HORAS, no una noche: en el calendario por
  // días se lee como un bloqueo con su motivo.
  hourly: {
    sold: "Vendida à hora",
    soldOne: "Vendida à hora · {range}",
    soldMany: "Vendida à hora · {count} estadias",
  },
  tooltip: {
    past: "Passada",
    unassignedHtml: "<strong>Sem quarto atribuído.</strong> A disponibilidade está distribuída entre os quartos. Use <strong>Organizar</strong> para reorganizá-la automaticamente, ou clique e atribua um quarto a ela.",
    nights: "{count} noite | {count} noites",
    guests: "{count} hóspede | {count} hóspedes",
  },
  channels: {
    direct: "Direta",
  },
  syncModal: {
    title: "Sincronizar com a OTA",
    message: "A disponibilidade e a estadia máxima deste calendário serão recalculadas e reenviadas à OTA.",
    confirm: "Sim, sincronizar",
    cancel: "Cancelar",
  },
  syncTooltip: {
    can: "Recalcula e reenvia à OTA a disponibilidade e a estadia máxima (evita overbooking).",
    cannot: "Conecte a acomodação a um canal para poder sincronizar.",
  },
  block: {
    editTitle: "Alterar motivo",
    createTitle: "Bloquear quarto",
    reasonLabel: "Motivo do bloqueio",
    reasonHint: "(será exibido no calendário)",
    placeholder: "Ex: Manutenção, uso do proprietário…",
    cancel: "Cancelar",
    saving: "Salvando…",
    saveReason: "Salvar motivo",
    blockBtn: "Bloquear",
    defaultReason: "Bloqueado",
    thisRoom: "este quarto",
    editReasonMsg: `Alterar o motivo do bloqueio de "{room}" ({count} noite). | Alterar o motivo do bloqueio de "{room}" ({count} noites).`,
    createMsg: `"{room}" ({unit}) será fechado por {count} noite. Não será possível reservar nele nessas datas; os demais quartos do tipo continuam disponíveis. | "{room}" ({unit}) será fechado por {count} noites. Não será possível reservar nele nessas datas; os demais quartos do tipo continuam disponíveis.`,
    presets: {
      maintenance: "Manutenção",
      ownerUse: "Uso do proprietário",
      renovation: "Reforma",
      deepCleaning: "Limpeza profunda",
      externalReserved: "Reservado (externo)",
    },
  },
  organizeModal: {
    title: "Organizar automaticamente",
    bodyHtml: `Buscaremos o melhor arranjo e <strong>reorganizaremos as reservas entre os quartos</strong> deste tipo para que <strong>{count} reserva sem alocação caiba</strong> de forma corrida. | Buscaremos o melhor arranjo e <strong>reorganizaremos as reservas entre os quartos</strong> deste tipo para que <strong>{count} reservas sem alocação caibam</strong> de forma corrida.`,
    point1Html: "Muda apenas o <strong>quarto físico</strong> atribuído.",
    point2Html: "Não são alterados <strong>datas, preços nem hóspedes</strong>.",
    point3: "Se alguma não couber de forma corrida, avisaremos você.",
    cancel: "Cancelar",
    organizing: "Organizando…",
    confirm: "Sim, organizar",
  },
  empty: {
    noHotelTitle: "Sem anúncios do tipo hotel",
    noHotelSubHtml: "Crie um anúncio do tipo <strong>Hotel</strong> ou <strong>Camping</strong> para começar a gerenciar a disponibilidade por quartos.",
    noHotelBtn: "Ir para anúncios",
    noRoomsTitle: "{name} não tem quartos",
    noRoomsSub: "Este anúncio ainda não tem quartos cadastrados. Adicione quartos nas configurações do anúncio para ver o calendário.",
    noRoomsBtn: "Configurar anúncio",
  },
  mock: {
    today: "Hoje",
    month: "MAIO DE 2026",
    searchPlaceholder: "Buscar por nome ou código…",
    searchBtn: "Buscar",
    createBtn: "Criar reserva",
    na: "N/D",
    forSaleLabel: "Disp. à venda",
    suiteDeluxe: "Suíte Deluxe",
    standardRoom: "Quarto Padrão",
    roomsCount2: "(2 qtos)",
    roomsCount3: "(3 qtos)",
    no: "Nº",
    room101: "Quarto 101",
    room102: "Quarto 102",
    room201: "Quarto 201",
    room202: "Quarto 202",
    room203: "Quarto 203",
    d1: "seg 1",
    d2: "ter 2",
    d3: "qua 3",
    d4: "qui 4",
    d5: "sex 5",
    d6: "sáb 6",
    d7: "dom 7",
    d8: "seg 8",
    d9: "ter 9",
    d10: "qua 10",
    d11: "qui 11",
    d12: "sex 12",
  },
  ops: {
    closingDay: "Fechando dia…",
    openingDay: "Abrindo dia…",
    saving: "Salvando…",
    movingBlock: "Movendo bloqueio…",
    swappingBlockReservation: "Trocando bloqueio e reserva…",
    swappingReservationBlock: "Trocando reserva e bloqueio…",
    swappingRooms: "Trocando quartos…",
    changingRoom: "Trocando de quarto…",
    organizingRooms: "Organizando quartos…",
    syncingWithOta: "Sincronizando calendário com a OTA…",
    processing: "Processando…",
    settingMaintenance: "Colocando em manutenção…",
    clearingMaintenance: "Removendo manutenção…",
    updatingAvailability: "Atualizando disponibilidade…",
    updatingReason: "Atualizando motivo…",
    closingRoom: "Fechando quarto…",
    removingBlock: "Removendo bloqueio…",
  },
  toasts: {
    dayClosed: "Dia fechado",
    dayOpened: "Dia aberto",
    availabilityUpdateErr: "Não foi possível atualizar a disponibilidade",
    dayUpdated: "Dia atualizado",
    daySaveErr: "Não foi possível salvar o dia",
    moveTargetMultipleReservations: "O destino tem várias reservas nesse intervalo; mova-as manualmente.",
    roomRejectsBlock: "Esse quarto não aceita o bloqueio nesse intervalo",
    blockMoved: "Bloqueio movido de quarto",
    blockMoveErr: "Não foi possível mover o bloqueio",
    swapStartErr: "Não foi possível iniciar a troca",
    reservationNoFitSwap: "A reserva não cabe no outro quarto em todo o seu intervalo; não foi possível trocar.",
    reservationMoveErr: "Não foi possível mover a reserva",
    swapCompleteErr: "Não foi possível concluir a troca (foi revertida)",
    blockReservationSwapped: "Bloqueio e reserva trocados",
    swapErr: "Não foi possível trocar",
    rangeHasOccupiedOrClosed: "O intervalo inclui noites ocupadas ou fechadas neste quarto.",
    organizeErr: "Não foi possível organizar automaticamente.",
    organizeNothing: "Não havia nada para reorganizar.",
    organizePartial: "{done} reserva(s) foram organizadas, mas {unplaced} não cabe(m) de forma corrida em nenhuma combinação.",
    organizeDoneAssigned: "Calendário organizado: {assigned} alocada(s)",
    organizeDoneMoved: ", {moved} movida(s) de quarto",
    swapGroupDone: "Troca em grupo concluída: {groupCount} ⇄ {swappedCount} reservas.",
    roomsSwappedWith: "Quartos trocados com {names}.",
    noPropertyToSync: "Não há acomodação para sincronizar.",
    calendarResynced: "Calendário recalculado e sincronizado com a OTA.",
    syncErr: "Não foi possível sincronizar o calendário com a OTA.",
    genericError: "Erro",
    reservationNoFitSwapStrict: "Não foi possível trocar: a reserva não fica livre em todo o seu intervalo.",
    reservationBlockSwapped: "Reserva e bloqueio trocados",
    roomCloseErr: "Não foi possível fechar o quarto",
    reasonUpdated: "Motivo atualizado",
    roomClosedInRange: "Quarto fechado no intervalo",
    blockRemoved: "Bloqueio removido",
    blockRemoveErr: "Não foi possível remover o bloqueio",
    searchMinChars: "Digite pelo menos 2 caracteres para buscar",
    searchNoResults: "Nenhuma reserva encontrada para essa busca",
    searchErr: "Erro ao buscar reservas",
  },
  summary: {
    stateAvailable: "Disponível",
    stateClosed: "Fechado",
    stateNoDisp: "Indisp.",
  },
};
